import React from "react";

const Container = ({ children }) => {
  return <div className="mx-auto max-w-[90%]">{children}</div>;
};

export default Container;
